import { JobStatus } from 'features/myJobs';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Status, { StatusProps } from '../Status';

interface ProcessedOfferStatusProps {
    className?: string;
    status?: JobStatus;
}

function ProcessedOfferStatus({ className, status }: ProcessedOfferStatusProps) {
    const { t } = useTranslation('candidateOffers', { keyPrefix: 'offerStatus' });

    const statusProps = useMemo<StatusProps | null>(() => {
        switch (status) {
            case 'applied':
                return {
                    variant: 'warning',
                    content: t('applied')
                };
            case 'declinedByCandidate':
                return {
                    variant: 'warning',
                    content: t('declinedByCandidate')
                };
            case 'rejected':
                return {
                    variant: 'error',
                    content: t('rejected')
                };
            case 'confirmed':
                return {
                    variant: 'success',
                    content: t('confirmed')
                };
            default:
                return null;
        }
    }, [ status, t ]);

    if (!statusProps) {
        return null;
    }

    return (
        <Status { ...statusProps }
            className={ className }
        />
    );
}

export default memo(ProcessedOfferStatus);
